<template lang="pug">
  main.projects(v-if="settings")
    header.header
      main-menu
    section.section
      div.container
        div.intro
          h1.title {{ settings.sections.projects.title }}
          div(v-html="settings.sections.projects.subtitle")
        div.filters(:class="{open: filtersOpen}")
          p.is-hidden-tablet(@click="openFilters") Filter By
            span(v-if="filtersOpen") -
            span(v-else) +
          div.wrapper
            div.year
              label year
              v-select(
                :value.sync="defaultAll"
                :options="years",
                :on-change="yearProjects",
                :searchable="true"
              )
            div.location
              label location
              v-select(
                :value.sync="defaultAll"
                :options="locations"
                :on-change="locationProjects"
                :searchable="true"
              )
            form.type
              label type
              div
                input(
                  type="checkbox"
                  name="drifters"
                  id="typeDrifters"
                  value="drifter"
                  v-model="checkedType"
                  @change="typeProjects"
                )
                label(for="typeDrifters") drifters
                  span(class="checkmark")
              div
                input(
                  type="checkbox"
                  name="float"
                  value="float"
                  id="typeFloats"
                  v-model="checkedType"
                  @change="typeProjects"
                )
                label(for="typeFloats") float
                  span(class="checkmark")
              div
                input(
                  type="checkbox"
                  name="gliders"
                  value="glider"
                  id="typeGliders"
                  v-model="checkedType"
                  @change="typeProjects"
                )
                label(for="typeGliders") gliders
                  span(class="checkmark")
            form.status
              label status
              div
                input(type="radio" id="statusDead" value="Closed" v-model="status" @change="statusProjects")
                label(for="statusDead") closed
                  span(class="checkmark radio")
              div
                input(type="radio" id="statsuAlive" value="Ongoing" v-model="status" @change="statusProjects")
                label(for="statsuAlive") ongoing
                  span(class="checkmark radio")
            form.actions
              button(type="button" @click="resetFilters") Reset
      div
        div.projects.container
          h2.subtitle Latest Projects
          masonry(
            :cols="{default: 3, 1215: 2, 720: 1}"
            :gutter="20"
          )
            div.project(v-for="(project, index) in projects" :key="`project-${index}`")
              div
                h1 {{ project.name }}
                h3
                  span(v-for="(location, index) in project.location" :key="location.id") {{  location.name }}
                    template(v-if="index + 1 < project.location.length")  /&nbsp;
                ul
                  li
                    ul
                      li status
                      li {{ project.status }}
                    ul.type
                      li type
                      li.value
                        span(v-for="type in project.type") {{ type.replace(/\w/, c => c.toUpperCase()) }}
                    ul
                      li start date
                      li {{ project.date_start }}
                    ul
                      li end date
                      li {{ project.date_end || 'Not defined' }}
                p(v-if="project.description" v-html="project.description") a
                div.buttons
                  div
                    a(@click="viewMap(project)") mappa
                  div
                    router-link(:to="`projects/${project.nome_www}`") Project info
</template>

<script>
import moment from 'moment'
import VueSelect from 'vue-select'
import { mapState } from 'vuex'
import MainMenu from '@/components/MainMenu.vue'
export default {
  name: 'projects',
  metaInfo: {
    title: 'Projects'
  },
  components: {
    'main-menu': MainMenu,
    'v-select': VueSelect
  },
  computed: {
    ...mapState({
      settings: 'settings',
      years: 'years'
    }),
    locations () {
      return this.$store.getters.selectLocations
    },
    projects () {
      return this.$store.getters.projects
    }
  },
  data () {
    return {
      checkedType: [],
      filtersOpen: false,
      started: [],
      status: '',
      defaultAll: {value: null, id: null, label: 'ALL'},
      filters: {
        date_range: null,
        id_oceano: null,
        type: [],
        status: null
      }
    }
  },
  mounted () {
    this.$store.dispatch('LOAD_LOCATIONS_LIST')
    this.$store.dispatch('LOAD_YEARS_LIST')
    this.$store.dispatch('LOAD_PROJECT_LIST')
  },
  methods: {
    openFilters () {
      this.filtersOpen = !this.filtersOpen
    },
    yearProjects (year) {
      if (typeof year === 'string') {
        this.filters.date_range = year
        this.updatePrj()
      }
    },
    locationProjects (location) {
      this.filters.location = location.id
      this.updatePrj()
    },
    statusProjects () {
      this.filters.status = this.status
      this.updatePrj()
    },
    typeProjects () {
      this.filters.type = this.checkedType
      this.updatePrj()
    },
    updatePrj () {
      this.$store.commit('SET_PRJ_FILTERS', {
        dateRange: parseInt(this.filters.date_range, 10),
        idOceano: parseInt(this.filters.location, 10),
        status: this.filters.status,
        type: this.filters.type
      })
    },
    resetFilters () {
      this.filters.date_range = null
      this.filters.location = null
      this.filters.status = null
      this.filters.type = []
      this.status = null
      this.checkedType = []
      this.status = ''
      this.defaultAll = {value: null, id: null, label: 'ALL'}
      this.updatePrj()
    },
    viewMap (prj) {
      this.$store.dispatch('LOAD_PROJECT', prj.id_project).then(response => {
        this.$store.commit('SET_MAP_FILTERS', {
          location: prj.multipleLocations ? null : parseInt(prj.location[0].id, 10),
          dateFrom: prj.date_start,
          dateTo: prj.date_end_phy || moment().format('YYYY-MM-DD'),
          project: prj.id_project
        })
        this.$router.push({ path: '/data' })
      })
    }
  },
  beforeDestroy () {
    this.filtersOpen = false
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .header {
    background-image: url('../assets/projects-header.jpg');
  }

  .subtitle {
    margin: 0 auto;
    padding: 31px 0;
    color: #fff;
    font-family: 'Open Sans';
    font-weight: 400;
    font-style: normal;
    font-size: 18px;
    text-transform: uppercase;
  }

</style>



// WEBPACK FOOTER //
// src/views/Projects.vue